import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarProgramasInclusionRequest } from '../../models/cotizador-contratante/consultar-programas-inclusion/request/consultar-programas-inclusion-request.model';
import { ConsultarProgramasInclusionResponse } from '../../models/cotizador-contratante/consultar-programas-inclusion/response/consultar-programas-inclusion-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarProgramasInclusionService {
  private readonly url = `${environment.HOST}${URL_MAP.API.CONSULTAR_PROGRAMAS_INCLUSION}`;

  constructor(private http: HttpClient) {}

  /**
   * Programas del afiliado para flujo inclusión (tipoSolicitud 2).
   * nombreClave: ConsultarProgramasxAfiliado
   */
  consultarProgramasInclusion(tipoId: string, numId: string): Observable<ConsultarProgramasInclusionResponse> {
    const body: ConsultarProgramasInclusionRequest = {
      nombreClave: 'ConsultarProgramasxAfiliado',
      jsonParametros: JSON.stringify({
        tipoId: (tipoId ?? '').toString().trim(),
        numId: (numId ?? '').toString().trim()
      })
    };
    return this.http.post<ConsultarProgramasInclusionResponse>(this.url, body).pipe(
      catchError(err => {
        console.error('Error en consultarProgramasInclusion:', err);
        return throwError(() => new Error(err?.message || 'Error al consultar programas de inclusión'));
      })
    );
  }
}
